import { memo, useState } from "react";
import { TableItemId } from "../../../../../components/tables/TableWidget";
import { TableItemType } from "../../../../../components/tables/tableContext/TableContext";
import { useAppDispatch } from "../../../../../redux/hooks";
import { KTSVG } from "../../../../../helpers/KTSVG";
import CustomButton from "../../../../../components/CustomButton";
import { UndeliveredAwbDataInterface } from "../../../../../redux/interfaces/expedition.interface";
import {
  fetchPrintAwbA4,
  fetchPrintAwbZebra,
  fetchUndeliveredAwb,
  postAssociateAwbToBin,
  postCancelAwb,
  postMarkIndividualPackages,
} from "../../../../../redux/api/expedition.api";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../../helpers/apiHelper";
import SvgIcon from "../../../../../helpers/SvgIcon";
import {
  openChangeDateUndeliveredAwbModal,
  setClientSelectedUndeliveredAwb,
  setSelectedUndeliveredAwbForChangingDate,
} from "../../../../../redux/reducer/expedition.reducer";

function UndeliveredAwbTableActionButtons({
  itemId,
  crudData,
  tableContext,
}: {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData: UndeliveredAwbDataInterface;
  tableContext?: any;
}) {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const handleAssociateAwb = async () => {
    const resultAction = await dispatch(
      postAssociateAwbToBin({
        params: {
          id_doctrans: itemId,
        },
      }),
    );

    if (
      checkEndpointStatus(resultAction, postAssociateAwbToBin) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, postAssociateAwbToBin) ===
      endpointStatus.fulfilled
    ) {
      dispatch(
        fetchUndeliveredAwb({
          page: tableContext.tablePagination.page,
          perPage: tableContext.tablePagination.rowsPerPage,
          doc_trans: tableContext.tableSearch.doc_trans,
          pctlivrare: tableContext.tableSearch.pctlivrare,
          nodDestinatie: tableContext.tableFilter.nodDestinatie,
          status: tableContext.tableFilter.status,
        }),
      );
    }
  };

  const handlePrintAwbA4 = () => {
    if (itemId) {
      dispatch(
        fetchPrintAwbA4({
          idDocTrans: itemId,
        }),
      );
    }
  };

  const handlePrintAwbZebra = () => {
    if (itemId) {
      dispatch(
        fetchPrintAwbZebra({
          idDocTrans: itemId,
        }),
      );
    }
  };

  const handleSetSelectedClient = () => {
    dispatch(setClientSelectedUndeliveredAwb(crudData));
  };

  const handleChangePickingDate = () => {
    dispatch(setSelectedUndeliveredAwbForChangingDate(crudData));
    dispatch(openChangeDateUndeliveredAwbModal());
  };

  const handleCancelAwb = async () => {
    const resultAction = await dispatch(
      postCancelAwb({
        id_doctrans: crudData.id_doctrans,
      }),
    );

    if (
      checkEndpointStatus(resultAction, postCancelAwb) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, postCancelAwb) ===
      endpointStatus.fulfilled
    ) {
      dispatch(
        fetchUndeliveredAwb({
          page: tableContext.tablePagination.page,
          perPage: tableContext.tablePagination.rowsPerPage,
          doc_trans: tableContext.tableSearch.doc_trans,
          pctlivrare: tableContext.tableSearch.pctlivrare,
          nodDestinatie: tableContext.tableFilter.nodDestinatie,
          status: tableContext.tableFilter.status,
        }),
      );
    }
  };

  const handleMarkIndividualPackages = async () => {
    const resultAction = await dispatch(
      postMarkIndividualPackages({
        id_doctrans: crudData.id_doctrans,
      }),
    );

    if (
      checkEndpointStatus(resultAction, postMarkIndividualPackages) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, postMarkIndividualPackages) ===
      endpointStatus.fulfilled
    ) {
      dispatch(
        fetchUndeliveredAwb({
          page: tableContext.tablePagination.page,
          perPage: tableContext.tablePagination.rowsPerPage,
          doc_trans: tableContext.tableSearch.doc_trans,
          pctlivrare: tableContext.tableSearch.pctlivrare,
          nodDestinatie: tableContext.tableFilter.nodDestinatie,
          status: tableContext.tableFilter.status,
        }),
      );
    }
  };

  return (
    <div>
      {(crudData.status === 0 || crudData.status === 3) && (
        <CustomButton
          loading={isLoading}
          className="me-1  mb-1"
          variant="contained"
          color="warning"
          tooltipTitle="Colete individuale"
          withConfirmationModal={{
            modalTitle: "Colete cu livrare individuala",
            modalSubtitle: `Doriti sa marcati toate colete cu awb-ul ${crudData.doc_trans} ca fiind cu livrare individuala?`,
            modalLeftButtonVariant: "outlined",
            modalRightButtonOnClick: handleMarkIndividualPackages,
          }}>
          <SvgIcon type="PACKAGES" className="svg-icon-2" fill="white" />
        </CustomButton>
      )}

      {crudData?.id_doctrans && (
        <CustomButton
          loading={isLoading}
          className="me-1  mb-1"
          variant="contained"
          color="primary"
          tooltipTitle="Asociere expeditie"
          withConfirmationModal={{
            modalTitle: "Asociere expeditie",
            modalSubtitle: `Doriti sa adaugati coletul la binurile de pe nodul ${crudData.nodDestinatie}?`,
            modalLeftButtonVariant: "outlined",
            modalRightButtonOnClick: handleAssociateAwb,
          }}>
          <KTSVG
            path="/media/svg/reception/associate.svg"
            className="svg-icon-2"
            fill="white"
          />
        </CustomButton>
      )}

      <CustomButton
        variant="contained"
        className="me-1  mb-1"
        tooltipTitle="Print A4"
        onClick={handlePrintAwbA4}>
        <SvgIcon type="PRINT_A4" fill="white" className="svg-icon-2" />
      </CustomButton>

      <CustomButton
        variant="contained"
        className="me-1  mb-1"
        tooltipTitle="Print Zebra"
        onClick={handlePrintAwbZebra}>
        <SvgIcon type="PRINT_ZEBRA" className="svg-icon-2" />
      </CustomButton>

      <CustomButton
        variant="contained"
        className="me-1  mb-1"
        tooltipTitle="Schimbare punct lucru"
        onClick={handleSetSelectedClient}>
        <SvgIcon
          type="CHANGE_WORKING_POINT"
          className="svg-icon-2"
          fill="white"
        />
      </CustomButton>

      <CustomButton
        variant="contained"
        className="me-1  mb-1"
        tooltipTitle="Schimbare data ridicarii"
        onClick={handleChangePickingDate}>
        <SvgIcon type="CHANGE_DATE" className="svg-icon-2" fill="white" />
      </CustomButton>

      {crudData.status === 0 && (
        <CustomButton
          loading={isLoading}
          className="me-1  mb-1"
          variant="contained"
          color="error"
          tooltipTitle="Anuleaza AWB"
          withConfirmationModal={{
            modalTitle: "Anuleaza AWB",
            modalSubtitle: `Doriti sa anulati awb-ul ${crudData.doc_trans}?`,
            modalLeftButtonVariant: "outlined",
            modalRightButtonOnClick: handleCancelAwb,
          }}>
          <SvgIcon type="CANCEL" className="svg-icon-2" fill="white" />
        </CustomButton>
      )}
    </div>
  );
}

export default memo(UndeliveredAwbTableActionButtons);
